export default "__VITE_ASSET__fb1da000__"